export const InsightsTypes = {
  GENERATE_REQUEST: '@insights/GENERATE_REQUEST',
  GENERATE_SUCCESS: '@insights/GENERATE_SUCCESS',
  GENERATE_FAILURE: '@insights/GENERATE_FAILURE',
  LIST_REQUEST: '@insights/LIST_REQUEST',
  LIST_SUCCESS: '@insights/LIST_SUCCESS',
  LIST_FAILURE: '@insights/LIST_FAILURE',
  SELECT_INSIGHT: '@insights/SELECT_INSIGHT',
};

export interface TradeSummary {
  totalTrades: number;
  totalWins: number;
  totalLosses: number;
  totalPnL: number;
  winRate: number;
}

export interface Sections {
  strengths: string;
  weaknesses: string;
  strategies: string;
  patterns: string;
  riskManagement: string;
  actionPlan: string;
}

export interface InsightItem {
  _id: string;
  userId: string;
  generatedAt: string;
  periodStart: string;
  periodEnd: string;
  score: number;
  scoreExplanation: string;
  tradeSummary: TradeSummary;
  sections: Sections;
}

export interface UsageInfo {
  plan: string;
  limit: number;
  used: number;
  remaining: number;
  resetsAt: string | null;
}

export interface InsightsState {
  generating: boolean;
  currentInsight: InsightItem | null;
  history: InsightItem[];
  historyLoading: boolean;
  total: number;
  page: number;
  totalPages: number;
  error: string | null;
  usage: UsageInfo | null;
}
